import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    console.log("Hello, Admin Recap Block Example Controller here!", this.element);
  }

  updatePrompt(event) {
    console.log("Hello, Admin Recap Block Example Controller here!", event.target.value);

    const block = document.querySelector(`.block-${event.target.value}`);
    const text = block.textContent.replace(/[<>]/g, c => ({ '<': '&lt;', '>': '&gt;' }[c])).trim();

    document.querySelector('#prompt-preview').innerHTML = text;
    document.querySelector('.sidebar').style.width = '50%';
  }

}
